import { useContext, useEffect, useRef } from "react";

import { HasbotContext } from "../context/hasBot-context";
import { useAiSmeChat } from "../hooks/useAiSmeChat";
import { useAiSmeChatConfig } from "../hooks/useAiSmeChatConfig";
import { useAppState } from "../hooks/useAppState";
import HelpAndSupportDialog from "./HelpAndSupportDialog";

export function HelpAndSupportApp() {
  const { showDialog, aiChatActive } = useContext(HasbotContext);
  const { course } = useAppState();
  const prevCourseIdRef = useRef<number | undefined>(course?.trainingId);
  const { isLoading: isAiChatConfigLoading, enabled: isAiChatEnabled } = useAiSmeChatConfig();

  const chat = useAiSmeChat({
    enabled: !isAiChatConfigLoading && isAiChatEnabled,
    onError: (error: Error) => {
      console.error("AI SME Chat error:", error);
      // Telemetry is fired in the dialog component when error displays
    },
    onFinish: () => {
      // Called when the chat is finished
    },
    onData: () => {
      // Called for each chunk during streaming
    },
  });

  // Close connection when dialog is explicitly closed
  useEffect(() => {
    if (!aiChatActive && (chat.status === "submitted" || chat.status === "streaming")) {
      chat.stop?.();
    }
  }, [aiChatActive, chat]);

  // Close connection and clear messages when course changes
  useEffect(() => {
    const currentCourseId = course?.trainingId;
    if (prevCourseIdRef.current && prevCourseIdRef.current !== currentCourseId && aiChatActive) {
      chat.stop?.();
      chat.setMessages([]);
    }
    prevCourseIdRef.current = currentCourseId;
  }, [course?.trainingId, chat, aiChatActive]);

  if (showDialog) return <HelpAndSupportDialog chat={chat} />;
  return null;
}
